import { render, staticRenderFns } from "./add-user.vue?vue&type=template&id=61820222&scoped=true&"
import script from "./add-user.vue?vue&type=script&lang=ts&"
export * from "./add-user.vue?vue&type=script&lang=ts&"
import style0 from "./add-user.vue?vue&type=style&index=0&id=61820222&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61820222",
  null
  
)

export default component.exports